import React from 'react';

const ChartContext = React.createContext({
  exportGanttChart: () => {}
});

export default ChartContext;
